import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CommonButton from "../../ui/inputs/CommonButton.js";
import { colors } from "../../../../theme/colors.js";
import { layoutSizes } from "../../../../theme/index.js";
// Specific card themes mapped by game type
const CARD_TYPE_THEMES = {
  JACKPOT: {
    accentColor: colors.emerald[600],
    background:
      "linear-gradient(145deg, rgba(255, 255, 255, 0.96) 0%, rgba(240, 253, 248, 0.90) 45%, rgba(209, 250, 229, 0.55) 100%)",
    ambientGlow:
      "radial-gradient(circle at 85% 25%, rgba(16, 185, 129, 0.22) 0%, rgba(5, 150, 105, 0.10) 42%, rgba(209, 250, 229, 0.02) 70%, transparent 100%)",
    border: "1px solid rgba(16, 185, 129, 0.22)",
    hoverBorder: "1px solid rgba(16, 185, 129, 0.50)",
    boxShadow:
      "-4px -4px 8px rgba(5, 150, 105, 0.12), -1px -1px 3px rgba(5, 150, 105, 0.04)",
    hoverBoxShadow:
      "-8px -8px 14px rgba(5, 150, 105, 0.22), -2px -2px 8px rgba(5, 150, 105, 0.10)",
    overlayGradient:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.88) 0%, rgba(236, 253, 245, 0.60) 38%, rgba(255, 255, 255, 0.15) 75%, rgba(255, 255, 255, 0) 100%)",
    badgeBg: "rgba(5, 150, 105, 0.10)",
    badgeBorder: "1px solid rgba(5, 150, 105, 0.22)",
    badgeColor: colors.emerald[700] || colors.emerald[600],
  },
  SPINNER: {
    accentColor: colors.primary.main,
    background:
      "linear-gradient(145deg, rgba(255, 255, 255, 0.96) 0%, rgba(244, 248, 255, 0.90) 45%, rgba(219, 234, 254, 0.55) 100%)",
    ambientGlow:
      "radial-gradient(circle at 85% 25%, rgba(37, 99, 235, 0.20) 0%, rgba(59, 130, 246, 0.10) 42%, rgba(219, 234, 254, 0.02) 70%, transparent 100%)",
    border: "1px solid rgba(37, 99, 235, 0.20)",
    hoverBorder: "1px solid rgba(37, 99, 235, 0.50)",
    boxShadow:
      "-4px -4px 8px rgba(37, 99, 235, 0.12), -1px -1px 3px rgba(37, 99, 235, 0.04)",
    hoverBoxShadow:
      "-8px -8px 14px rgba(37, 99, 235, 0.22), -2px -2px 8px rgba(37, 99, 235, 0.10)",
    overlayGradient:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.88) 0%, rgba(239, 246, 255, 0.60) 38%, rgba(255, 255, 255, 0.15) 75%, rgba(255, 255, 255, 0) 100%)",
    badgeBg: "rgba(37, 99, 235, 0.10)",
    badgeBorder: "1px solid rgba(37, 99, 235, 0.22)",
    badgeColor: colors.primary.main,
  },
  MINES: {
    accentColor: colors.purple[600],
    background:
      "linear-gradient(145deg, rgba(255, 255, 255, 0.96) 0%, rgba(252, 248, 255, 0.90) 45%, rgba(237, 222, 255, 0.55) 100%)",
    ambientGlow:
      "radial-gradient(circle at 85% 25%, rgba(124, 58, 237, 0.20) 0%, rgba(139, 92, 246, 0.10) 42%, rgba(233, 213, 255, 0.02) 70%, transparent 100%)",
    border: "1px solid rgba(124, 58, 237, 0.20)",
    hoverBorder: "1px solid rgba(124, 58, 237, 0.50)",
    boxShadow:
      "-4px -4px 8px rgba(124, 58, 237, 0.12), -1px -1px 3px rgba(124, 58, 237, 0.04)",
    hoverBoxShadow:
      "-8px -8px 14px rgba(124, 58, 237, 0.22), -2px -2px 8px rgba(124, 58, 237, 0.10)",
    overlayGradient:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.88) 0%, rgba(250, 245, 255, 0.60) 38%, rgba(255, 255, 255, 0.15) 75%, rgba(255, 255, 255, 0) 100%)",
    badgeBg: "rgba(124, 58, 237, 0.10)",
    badgeBorder: "1px solid rgba(124, 58, 237, 0.22)",
    badgeColor: colors.purple[600],
  },
  ROCKET: {
    accentColor: colors.amber[600],
    background:
      "linear-gradient(145deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 252, 240, 0.90) 45%, rgba(254, 238, 175, 0.55) 100%)",
    ambientGlow:
      "radial-gradient(circle at 85% 25%, rgba(217, 119, 6, 0.22) 0%, rgba(245, 158, 11, 0.10) 42%, rgba(254, 230, 138, 0.02) 70%, transparent 100%)",
    border: "1px solid rgba(217, 119, 6, 0.22)",
    hoverBorder: "1px solid rgba(217, 119, 6, 0.50)",
    boxShadow:
      "-4px -4px 8px rgba(217, 119, 6, 0.12), -1px -1px 3px rgba(217, 119, 6, 0.04)",
    hoverBoxShadow:
      "-8px -8px 14px rgba(217, 119, 6, 0.22), -2px -2px 8px rgba(217, 119, 6, 0.10)",
    overlayGradient:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.88) 0%, rgba(255, 251, 235, 0.60) 38%, rgba(255, 255, 255, 0.15) 75%, rgba(255, 255, 255, 0) 100%)",
    badgeBg: "rgba(217, 119, 6, 0.10)",
    badgeBorder: "1px solid rgba(217, 119, 6, 0.22)",
    badgeColor: colors.amber[700] || colors.amber[600],
  },
  SLOT: {
    accentColor: colors.red[500],
    background:
      "linear-gradient(145deg, rgba(255, 255, 255, 0.96) 0%, rgba(255, 241, 242, 0.90) 45%, rgba(254, 205, 211, 0.55) 100%)",
    ambientGlow:
      "radial-gradient(circle at 85% 25%, rgba(239, 68, 68, 0.20) 0%, rgba(244, 63, 94, 0.10) 42%, rgba(254, 205, 211, 0.02) 70%, transparent 100%)",
    border: "1px solid rgba(239, 68, 68, 0.20)",
    hoverBorder: "1px solid rgba(239, 68, 68, 0.50)",
    boxShadow:
      "-4px -4px 8px rgba(239, 68, 68, 0.12), -1px -1px 3px rgba(239, 68, 68, 0.04)",
    hoverBoxShadow:
      "-8px -8px 14px rgba(239, 68, 68, 0.22), -2px -2px 8px rgba(239, 68, 68, 0.10)",
    overlayGradient:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.88) 0%, rgba(255, 241, 242, 0.60) 38%, rgba(255, 255, 255, 0.15) 75%, rgba(255, 255, 255, 0) 100%)",
    badgeBg: "rgba(239, 68, 68, 0.10)",
    badgeBorder: "1px solid rgba(239, 68, 68, 0.22)",
    badgeColor: colors.red[500],
  },
};

const getCardTypeTheme = (type, explicitAccent) => {
  const normalizedType = String(type || "").trim().toUpperCase();

  let themeConfig = null;
  if (
    normalizedType.includes("JACKPOT") ||
    normalizedType.includes("MEGA") ||
    normalizedType.includes("MRL")
  ) {
    themeConfig = CARD_TYPE_THEMES.JACKPOT;
  } else if (
    normalizedType.includes("SPIN") ||
    normalizedType.includes("ROULETTE") ||
    normalizedType.includes("REVOLVER")
  ) {
    themeConfig = CARD_TYPE_THEMES.SPINNER;
  } else if (normalizedType.includes("MINE")) {
    themeConfig = CARD_TYPE_THEMES.MINES;
  } else if (
    normalizedType.includes("ROCKET") ||
    normalizedType.includes("MISSILE") ||
    normalizedType.includes("POKIE")
  ) {
    themeConfig = CARD_TYPE_THEMES.ROCKET;
  } else if (normalizedType.includes("SLOT")) {
    themeConfig = CARD_TYPE_THEMES.SLOT;
  }

  const effectiveAccent = explicitAccent || themeConfig?.accentColor || colors.primary.main;

  if (themeConfig) {
    return {
      ...themeConfig,
      accentColor: effectiveAccent,
    };
  }

  // Fallback for custom or unknown types
  return {
    accentColor: effectiveAccent,
    background:
      "linear-gradient(145deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.90) 45%, rgba(241, 245, 249, 0.60) 100%)",
    ambientGlow: `radial-gradient(circle at 85% 25%, ${effectiveAccent}30 0%, ${effectiveAccent}12 42%, transparent 70%)`,
    border: `1px solid ${effectiveAccent}33`,
    hoverBorder: `1px solid ${effectiveAccent}80`,
    boxShadow: `-4px -4px 8px ${effectiveAccent}18, -1px -1px 3px rgba(0, 0, 0, 0.04)`,
    hoverBoxShadow: `-8px -8px 14px ${effectiveAccent}2e, -2px -2px 8px ${effectiveAccent}15`,
    overlayGradient:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.55) 38%, rgba(255, 255, 255, 0.12) 75%, rgba(255, 255, 255, 0) 100%)",
    badgeBg: `${effectiveAccent}18`,
    badgeBorder: `1px solid ${effectiveAccent}33`,
    badgeColor: effectiveAccent,
  };
};

const PopularGamesCard = ({
  image,
  title,
  type,
  description,
  infoLabel,
  infoValue,
  buttonText = "Play Now",
  onClick,
  accentColor,
}) => {
  const cardTheme = getCardTypeTheme(type, accentColor);
  const finalAccent = cardTheme.accentColor;

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: "pointer",
        position: "relative",
        width: "100%",
        maxWidth: { xs: "280px", md: "none" },
        minHeight: { xs: "240px", sm: "280px" },
        borderRadius: "16px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        background: cardTheme.background,
        border: cardTheme.border,
        boxShadow: cardTheme.boxShadow,
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        transition: "transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease",
        "&:hover": {
          transform: "scale(1.05)",
          boxShadow: cardTheme.hoverBoxShadow,
          borderColor: cardTheme.hoverBorder,
        },
        "&:hover .popular-games-card-image": { transform: "scale(1.15)", opacity: 1 },
        "&:hover .popular-games-card-overlay": { opacity: 0.15 },
        "&:hover .popular-games-card-glow": { opacity: 0.4, transform: "scale(0.08)" },
      }}
    >
      {/* Type-based Ambient Lighting / Radial Glow Backdrop */}
      <Box
        className="popular-games-card-glow"
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background: cardTheme.ambientGlow,
          opacity: 0.3,
          transition: "opacity 0.4s ease, transform 0.4s ease",
          zIndex: 0,
        }}
      />

      {/* Background Image with Masking */}
      <Box
        className="popular-games-card-image"
        sx={{
          position: "absolute",
          inset: "-5%",
          width: "110%",
          height: "110%",
          pointerEvents: "none",
          backgroundImage: `url(${image})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          maskImage: (theme) =>
            `linear-gradient(135deg, transparent 0%, ${theme.custom.colors.alpha.black[25]} 28%, ${theme.custom.colors.alpha.black[75]} 55%, ${theme.palette.common?.black || "#000"} 78%)`,
          WebkitMaskImage: (theme) =>
            `linear-gradient(135deg, transparent 0%, ${theme.custom.colors.alpha.black[25]} 28%, ${theme.custom.colors.alpha.black[75]} 55%, ${theme.palette.common?.black || "#000"} 78%)`,
          opacity: 0.95,
          transform: "scale(1)",
          transformOrigin: "center center",
          transition: "transform 0.55s ease, opacity 0.35s ease",
          willChange: "transform",
          zIndex: 1,
        }}
      />

      {/* Glass Overlay (Fades on hover) */}
      <Box
        className="popular-games-card-overlay"
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          zIndex: 1,
          transition: "opacity 0.35s ease",
          background: cardTheme.overlayGradient,
        }}
      />

      {/* Card Content Container */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          minHeight: { xs: "240px", sm: "280px" },
          display: "flex",
          flexDirection: "column",
          p: layoutSizes.homeCardPadding,
          boxSizing: "border-box",
        }}
      >
        {/* Header: Title & Type Badge */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Typography
            component="h3"
            sx={(theme) => ({
              ...(theme.typography.homeSection?.cardHeading || {}),
              color: "secondary.dark",
              "@media (max-width: 600px)": {
                fontSize: "20px",
                lineHeight: 1.1,
              },
            })}
          >
            {title}
          </Typography>

          <Box
            sx={{
              flexShrink: 0,
              px: 1,
              py: 0.35,
              borderRadius: "999px",
              backgroundColor: cardTheme.badgeBg,
              border: cardTheme.badgeBorder,
              color: cardTheme.badgeColor,
              fontSize: "10px",
              lineHeight: 1.2,
              fontWeight: 700,
              letterSpacing: "0.3px",
            }}
          >
            {type}
          </Box>
        </Stack>

        {/* Description */}
        <Typography
          sx={{
            mt: 0.7,
            maxWidth: "62%",
            fontSize: "12px",
            lineHeight: 1.4,
            color: "custom.colors.alpha.navy[58]",
          }}
        >
          {description}
        </Typography>

        {/* Game Information (Pushed to bottom) */}
        <Box sx={{ mt: "auto", mb: 1.3 }}>
          <Typography
            sx={{
              fontSize: "10px",
              lineHeight: 1.2,
              color: "custom.colors.alpha.navy[52]",
              mb: 0.35,
            }}
          >
            {infoLabel}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: 1.15,
              fontWeight: 700,
              color: "secondary.dark",
            }}
          >
            {infoValue}
          </Typography>
        </Box>

        {/* Call to Action */}
        <CommonButton
          variant="contained"
          size="small"
          fullWidth
          onClick={onClick}
          label={buttonText}
          sx={{
            minHeight: "36px",
            height: "36px",
            py: 0,
            px: 2,
            borderRadius: "7px",
            backgroundColor: finalAccent,
            boxShadow: `4px 0 8px ${finalAccent}35`,
            "&:hover": {
              backgroundColor: finalAccent,
              filter: "brightness(0.95)",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default PopularGamesCard;